"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoMessage = void 0;
var React = require("react");
var Keyboard_1 = require("../../_Core/Keyboard");
var AlertOutlineIcon_1 = require("../../Icons/Assets/AlertOutlineIcon");
var Localization_1 = require("../../Localization");
var InfoMessage_styles_1 = require("./InfoMessage.styles");
var InfoMessage = function (_a) {
    var Message = _a.Message;
    var _b = React.useState(false), showMessage = _b[0], setShowMessage = _b[1];
    var _c = React.useState(false), hoverMessage = _c[0], setHoverMessage = _c[1];
    var buttonRef = React.createRef();
    var messageRef = React.createRef();
    React.useEffect(function () {
        document.addEventListener("click", handleDocumentClick);
        return function () {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [showMessage]);
    React.useEffect(function () {
        if (showMessage) {
            messageRef.current.focus();
        }
    }, [showMessage]);
    var handleDocumentClick = function () {
        showHideMessage(false);
    };
    var handleButtonClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        showHideMessage(!showMessage);
        buttonRef.current.focus();
    };
    var handleKeyUp = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        if (Keyboard_1.IsEscape(e)) {
            setShowMessage(false);
        }
    };
    var showHideMessage = function (show) {
        if (show) {
            setShowMessage(true);
        }
        else {
            setShowMessage(false);
            buttonRef.current.focus();
        }
    };
    return (React.createElement(InfoMessage_styles_1.WrapperDiv, null,
        React.createElement(InfoMessage_styles_1.Button, { type: "button", onMouseEnter: function () { return setHoverMessage(true); }, onMouseLeave: function () { return setHoverMessage(false); }, "aria-label": Localization_1.strings.Label_InfoMessage, onClick: handleButtonClick, ref: buttonRef, Hovered: showMessage || hoverMessage },
            React.createElement(InfoMessage_styles_1.IconContainerDiv, null,
                React.createElement(AlertOutlineIcon_1.AlertOutlineIcon, { Width: "20px", Height: "20px" }))),
        (showMessage || hoverMessage) && (React.createElement(InfoMessage_styles_1.MessageDiv, { ref: messageRef, onKeyUp: handleKeyUp, tabIndex: -1, role: "alert", "aria-live": "polite" }, Message))));
};
exports.InfoMessage = InfoMessage;
